import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import './index.css';
// import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { BrowserRouter } from 'react-router-dom';
import rootReducer from './resources/rootReducer';
import rootSaga from './resources/rootSaga';

import loggerMiddleware from './store/logger';

const enviroment = (process.env.REACT_APP_ENV || process.env.NODE_ENV).replace(/\s/g, '');

const sagaMiddleware = createSagaMiddleware();
// const middleware = [
//   ...getDefaultMiddleware({ thunk: false }),
//   loggerMiddleware,
//   sagaMiddleware,
// ];

const store = configureStore({
    reducer: rootReducer,
    // middleware,
    middleware: enviroment === 'development' ? [loggerMiddleware, sagaMiddleware] : [sagaMiddleware],
    devTools: enviroment !== 'production',
});

sagaMiddleware.run(rootSaga);

const container = document.getElementById('root')!;
const root = createRoot(container);
// const strictMode = true;
const strictMode = false;

const ProviderComponent = () => (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

root.render(
    strictMode ? (
        <React.StrictMode>
            <ProviderComponent />
        </React.StrictMode>
    ) : (
        <ProviderComponent />
    )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
